import { render, staticRenderFns } from "./mStories.vue?vue&type=template&id=a3f60c8a&"
import script from "./mStories.vue?vue&type=script&lang=js&"
export * from "./mStories.vue?vue&type=script&lang=js&"
import style0 from "./mStories.vue?vue&type=style&index=0&id=a3f60c8a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports